import { Score } from './Score';
import { Timer } from './Timer';

export const Scoreboard = () => {
  return (
    <div className='scoreboard'>
      <div className='scoreboard__left'>
        <div className='scoreboard__gamer'>
          <div className='scoreboard__blue'>
            <img src='/app/rock-scissors-paper/images/T-short-blue.png' alt='Вы' />
          </div>
          <div className='scoreboard__name'>Вы</div>
          <div></div>
        </div>
      </div>
      <div className='scoreboard__center'>
        <Score />
        <Timer />
      </div>
      <div className='scoreboard__right'>
        <div className='scoreboard__computer'>
          <div></div>
          <div className='scoreboard__name'>Компьютер</div>
          <div className='scoreboard__red'>
            <img src='/app/rock-scissors-paper/images/T-short-red.png' alt='Компьютер' />
          </div>
        </div>
      </div>
    </div>
  );
};
